enum ButtonSize {
	XS = 'xs',
	SM = 'sm',
	MD = 'md',
	LG = 'lg',
}

enum ButtonVariant {
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	SECONDARY_BORDER = 'secondaryBorder',
	HYPERLINK = 'hyperlink',
	ICON = 'icon',
	TABLEHEADER = 'tableHeader',
	PRIMARY_NEW = 'primaryNew',
	SECONDARY_NEW = 'secondaryNew',
	TERTIARY_NEW = 'tertiaryNew',
}

enum ButtonSpinnerColorMap {
	primary = 'white',
	secondary = 'secondary',
	accent = 'accent',
	white = 'primary',
}

export { ButtonSize, ButtonVariant, ButtonSpinnerColorMap };
